const {languagesMenu, loginUrl} = require('../../utils');
const {links} = require('../common');
const css = require('./mobile.scss');
const {radioInputName} = require('./mobileUtils');

module.exports = ({mainLinks, t, config, user}) => `
  <input type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.allClosed}" checked>
  <input type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.menuOpen}">
  <input type="radio" name="${radioInputName}" class="${css.hidden}" id="${css.languagesOpen}">
  <div class="${css.controls}">
    <a href="//wix.com/" class="${css.logo} ${css.controlLeft}" title="${t('title_wix_logo')}">
      <img src="${config.baseUrl}assets/wix.svg" class="${css.logoImg}" alt="Wix">
    </a>
    <label class="${css.visibleWhenMenuClosed} ${css.controlRight}" for="${css.menuOpen}">
      <img src="${config.baseUrl}assets/menu.svg" alt="${t('open_menu')}">
    </label>
    <label class="${css.visibleWhenMenuOpen} ${css.controlRight}" for="${css.allClosed}">
      <img src="${config.baseUrl}assets/close.svg" alt="${t('close')}">
    </label>
    <label class="${css.visibleWhenLanguagesOpen} ${css.controlLeft}" for="${css.menuOpen}">
      <img src="${config.baseUrl}assets/back.svg" alt="${t('back')}">
    </label>
  </div>
  <div class="${css.sections}">
    <section class="${css.section}">
      <h2 class="${css.sectionHeader} ${css.divider}">
        ${
          user ? `
            <img class="${css.profileImage}" src="${user.profileImage}" alt="${user.userName}">
            <span class="${css.profileRow}">${t('hello')},</span>
            <span class="${css.profileRow}">${user.userName}</span>
          ` : `
            <a href="${loginUrl(config)}" title="${t('title_signin')}">
              <i class="${css.icon} ${css.iconUser}" title="${t('signup_form_submit')}"></i>
              ${t('signup_form_submit')}
            </a>
          `
        }
      </h2>
      ${links(mainLinks, {
        list: css.menu,
        item: css.menuItem,
        itemContent: `${css.menuContent} ${css.link}`
      })}
    </section>
    <section class="${css.section} ${css.level2}">
      <h2 class="${css.sectionHeader} ${css.divider}">
        <span class="${css.headline}">${t('choose_language')}</span>
      </h2>
      ${links(languagesMenu(config.supportedLanguages), {
        list: css.menu,
        item: css.menuItem,
        itemContent: css.menuContent
      })}
    </section>
  </div>
`;



// WEBPACK FOOTER //
// ./templates/header/mobile.js